import React from 'react';
import { useSelector } from 'react-redux';
import Skeleton from 'wsm-skeleton';
import { selectIsTabbedLayout } from '../../../utilities/layout';

export const DetailsSkeletonContainerClasses = ['p-0', 'mt-8'];

// US2092262 — `mt-8` is skeleton-only: the rendered details container carries no
// top margin, so an off-view card reserved 48px here that it loses on render.
// `p-0` is deliberately kept — it suppresses 16px of container padding, and
// dropping it as well adds that height back and cancels most of the win
// (measured on the Hertz SRP: 32px recovered instead of 96px).
export const DetailsSkeletonHeightParityClasses = ['p-0'];

const DetailsSkeleton = () => {
	const isTabbedLayout = useSelector((state) => selectIsTabbedLayout(state));
	return (
		<>
			<div className="row" data-testid="details-skeleton">
				<div className="col-xs-6">
					<div className="skeleton-listing" />
				</div>
				<div className="col-xs-6">
					<div className="skeleton-listing" />
				</div>
			</div>
			{!isTabbedLayout && (
				<Skeleton
					skeletonClasses="ml-auto mt-6"
					width="48%"
					height="3rem"
					dataTestId="price-skeleton"
				/>
			)}
		</>
	);
};

export default DetailsSkeleton;
